import { Alert, Button, Flex } from '@chakra-ui/react'
import { useState } from 'react'

import { useAuth } from '@/context/AuthContext'
import { usePartner } from '@/context/PartnerContext'
import { useCancelContract } from '@/hooks/useWizard'
import { Cancellation } from '../icons'

export const CancelContract = ({ insuranceId, callback }: { insuranceId: number, callback: () => void }) => {
  const [confirmCancel, setConfirmCancel] = useState<boolean>(false)

  const { user } = useAuth()
  const { currentPartner } = usePartner()

  const { mutateAsync: cancelContract, isLoading: isCancelling, isError } = useCancelContract()

  const handleCancelConfirm = () => {
    setConfirmCancel(true)
  }

  const handleCancelContract = () => 
    cancelContract(insuranceId)
      .then((resp) => {
        if (resp.success) {
          callback()
        }
      })
      .finally(() => {
        setConfirmCancel(false)
      })

  return (
    <Flex flexDir='column' gap={4} mx={4} w={'full'}>
      {!confirmCancel && (
        <Button variant="solid" p={2} px={4} colorScheme="red" onClick={handleCancelConfirm}
          isDisabled={currentPartner?.partner === 'Jap' && !user?.autorizacePpz?.hasAuthorization}>
          {/* <Cancellation /> */}
          Stornovat pro chybu
        </Button>
      )}

      {confirmCancel && (
        <Flex sx={{ w: 'full', gap: 2, flexDir: { base: 'row', lg: 'column' } }}>
          <Button
            flexGrow={1}
            variant="solid"
            colorScheme="red"
            onClick={handleCancelContract}
            disabled={isCancelling}
          >
            <Cancellation />
            {isCancelling ? 'Stornuji...' : 'Opravdu stornovat?'}
          </Button>

          {!isCancelling && (
            <Button variant="outline" py={2} onClick={() => setConfirmCancel(false)}>
              Nestornovat
            </Button>
          )}
        </Flex>
      )}

      {isError && <Alert colorScheme="red">Při stornování došlo k chybě.</Alert>}
    </Flex>
  )
}
